export const BUDGET_PERIODS = ["day", "week", "month"] as const;
export type BudgetPeriod = (typeof BUDGET_PERIODS)[number];

export const PERIOD_SAID: Record<BudgetPeriod, string> = {
  day: "a day",
  week: "a week",
  month: "a month",
};

export const PERIOD_OWNS: Record<BudgetPeriod, string> = {
  day: "the day's",
  week: "the week's",
  month: "the month's",
};

export function isBudgetPeriod(said: string): said is BudgetPeriod {
  return (BUDGET_PERIODS as readonly string[]).includes(said);
}
